import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Users, UtensilsCrossed, Wallet, Phone, Download } from "lucide-react";
export default function BuiltOnHardWorkDrivenByResults() {
  const stats = [{
    id: 1,
    label: "COMMUNITY",
    value: "50,000+",
    subLabel: "Active Users in Toronto"
  }, {
    id: 2,
    label: "ORDERS",
    value: "125,000+",
    subLabel: "Shared Meal Success"
  }, {
    id: 3,
    label: "SAVINGS",
    value: "$450k+",
    subLabel: "Total Community Savings"
  }];
  return <section data-section-id="156487" id="built-on-hard-work" className="relative w-full py-24 md:py-32 overflow-hidden bg-background text-foreground">
      

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-radial-gradient from-primary/5 to-transparent pointer-events-none -z-0" />
    </section>;
}